import React from 'react';

import {
  Actions,
  Action,
  Stack,
  PeopleIcon,
  Help,
  HelpOutlineIcon,
} from '@gogame/components';

import SmartTooltip from 'scenes/Trackers/components/SmartTooltip/SmartTooltip';

const ActionsComponent = ({
  onUpdateMetric,
  onDeleteMetric,
  disabledMetricManagement,
  disabledSmartTooltip,
  ...option
}) => {
  const handleEditCustomMetric = () => {
    onUpdateMetric(option);
  };
  const handleDeleteCustomMetric = () => {
    onDeleteMetric(option);
  };
  const { actions = [] } = option;
  const editable = actions.includes('edit');
  const deletable = actions.includes('delete');
  const withTooltip = !option.categoryId && option.tooltip;
  return (
    <Stack
      direction={'row'}
      spacing={1}
      alignItems={'center'}
      justifyContent={'space-between'}
      style={withTooltip ? { marginRight: 12 } : {}}
    >
      {option.categoryId === 1 && option.isPublic ? (
        <PeopleIcon color={'action'} sx={{ fontSize: 14 }} />
      ) : null}
      {disabledMetricManagement ? null : (
        <Actions limit={1}>
          {editable ? (
            <Action
              id={'edit'}
              label={'Edit'}
              onClick={handleEditCustomMetric}
            />
          ) : null}
          {deletable ? (
            <Action
              id={'delete'}
              label={'Delete'}
              onClick={handleDeleteCustomMetric}
            />
          ) : null}
        </Actions>
      )}

      {withTooltip ? (
        disabledSmartTooltip ? (
          <Help placement={'bottom'}>{option.tooltip}</Help>
        ) : (
          <SmartTooltip
            anchor={<HelpOutlineIcon sx={{ fontSize: 16 }} color={'action'} />}
            name={option.fullDisplayName || option.displayName}
            formula={option.displayFormula}
            hint={option.hint}
            showGlossary={option.showGlossary}
            glossaryItems={option.glossaryItems}
          />
        )
      ) : null}
    </Stack>
  );
};

export default ActionsComponent;
